import { createTheme } from "@mui/material/styles";
//este e as pastas Entity e Routes tem codigos esclusivos deste app


export const theme = createTheme({
    typography: {
        useNextVariants: true,
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        
    },
    palette: {
        primary: {
            main: "#272727",

            contrastText: "#fff",
        },
        secondary: {
            main: "#999999",
            contrastText: "#000",
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                variant: "contained",
            },
        },
    },
});

export const themedark = createTheme({
    typography: {
        useNextVariants: true,
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        
    },

    palette: {
        mode: 'dark',
        background: {
            default: "#272727"
        },
        text: {
            primary: "#ffffff"
        },
        primary: {
            main: "#999999",
            contrastText: "#000",
        },
        secondary: {
            main: "#000000",
            contrastText: "#fff",
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiInput: {
            styleOverrides: {
                input: {
                    colorScheme: 'dark',                
                },
              },
        }
    },


});